import { z } from "zod";
import { userRoleSchema } from "../enums.js";
import { isoDateTimeSchema, nonEmptyStringSchema, uuidSchema } from "../primitives.js";

export const userSchema = z.object({
  id: uuidSchema,
  email: z.string().email(),
  display_name: z.string().nullable(),
  role: userRoleSchema,
  is_active: z.boolean(),
  created_at: isoDateTimeSchema,
  updated_at: isoDateTimeSchema,
});

export type User = z.infer<typeof userSchema>;

export const currentUserSchema = userSchema;

export const createResearchJobCriteriaSchema = z.record(z.string(), z.unknown());

export const createResearchJobInputSchema = z.object({
  query: nonEmptyStringSchema,
  region: nonEmptyStringSchema,
  criteria: createResearchJobCriteriaSchema.default({}),
  target_count: z.number().int().min(1).max(100),
});

export type CreateResearchJobInput = z.infer<typeof createResearchJobInputSchema>;
